export const q = [

  {
    "id": 6,
    "question": "Vad kan vi förvänta oss i framtiden för era tjänster?",
    "answer": "Vi är ständigt engagerade i att utveckla nya tjänster för att förbättra din övningskörningsupplevelse. Redan idag har vi några spännande tjänster på plats, och vi arbetar hårt för att introducera ännu fler funktioner som du kommer att älska. Håll ögonen öppna!"
  },

  {
    "id": 8,
    "question": "Hur skapar jag ett övningskörningskort med handledare?",
    "answer": "*Steg 1*: Skapa ett konto. *Steg 2*: Gå till 'Mitt övningskörningskort' och skapa ett nytt kort. *Steg 3*: Be din handledare att skapa ett konto. *Steg 4*: Lägg till din handledare genom att ange hans e-postadress under 'Menu - Lägg till handledare'. *Steg 5*: Din handledare loggar in och går till 'Menu - Elevens övningskort'."
  },  
  
  {
    "id": 9,
    "question": "Hur skapar jag ett övningskörningskort?",
    "answer": "*Steg 1*: Skapa ett konto. *Steg 2*: Gå till 'Mitt övningskörningskort' och skapa ett nytt kort. *Steg 3*: Klart."
  },
  
  {
    "id": 10,
    "question": "Hur använder jag övningskortet?",
    "answer": "Du kör bilen med din handledare och markerar varje delkategori. Det finns tre statusar för varje delmoment: *Börjat*, *Visad kunskap* och *Godkänd*. När du är *klar* med ett moment markerar du eller din handledare att du är *klar* och ni går vidare till nästa moment. Det finns instruktioner för varje steg som beskriver och tydliggör hur man gör för att genomföra delmomentet."
  },

  {
    "id": 11,
    "question": "För vem är Letsroll?",
    "answer": "Letsroll är för dig som har en privat övningskörning och vill ha ett enkelt och strukturerat sätt att följa din utveckling tillsammans med din handledare."
  },
  {
    "id": 12,
    "question": "Hur fungerar supporten?",
    "answer": "Vår support är alltid nära till hands! Vi ser till att svara på din fråga inom 24 timmar."
  },
  {
    "id": 13,
    "question": "Hur ändrar jag från manuell till automatväxellåda?",
    "answer": "Gå till *Mina inställningar* och klicka på *Dina uppgifter*. Skrolla ner till sektionen *Växellåda* och välj den växellåda du kör med."
  },
  {
    "id": 14,
    "question": "Vilka körkortskategorier finns tillgängliga?",
    "answer": "För närvarande erbjuder vi endast kategori B."
  },
  {
    "id": 15,
    "question": "Hur många övningskort kan jag ha?",
    "answer": "Du kan ha upp till 10 aktiva övningskort samtidigt."
  } ,

  {
    "id": 16,
    "question": "Hur många handledare kan jag ha?",
    "answer": "Du kan associera maximalt 1 handledare med ditt konto."
  } ,



];

